import MyPaymentsComponent from "src/components/MyPaymentsComponent";

export default function Transaction() {
  return <MyPaymentsComponent />;
}
